export default "__VITE_ASSET__Duf_XOIi__"